import formReducer from '../formsReducer'

const formName = 'reports/filter'

export default formReducer(formName)
